import { FillableComponentProps } from "../../../pages/calls/stepsConfig";

function Filler({ step }: FillableComponentProps) {
  return <div dangerouslySetInnerHTML={{ __html: step.content! }}></div>;
}

export default Filler;
